import './App.css';
import React, { useState , useEffect, useRef } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  NavLink,
  Outlet,
  Navigate,
  Link,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import AdminLogin from "./AdminLogin";
import Meta from './Meta';
import ProtectedRoute from "./ProtectedRoute";
import AdminPanel from "./AdminPanel";
import News from './News';
import Stock from './Stock';
import NewsDetail from './NewsDetail';
import { About } from "./About";
import { Services } from "./Services";
import { Contacts } from "./Contacts";
import { Requisites } from './Requisites';
import { Jobs } from './Jobs';
import { License } from './License';
import { Coverage } from './Coverage';
import  Help  from './Help';
import 'aos/dist/aos.css';
import AOS from 'aos';
import FizLico from './Fiz-lico';
import Business from "./Business";
import PrivateSector from "./Private-sector";
import Video from "./Video";
import Outsourcing from "./Outsourcing";
import VirtualOfficePage from "./VirtualOffice";
import VoipServices from "./VoipServices";
import DedicatedChannels from "./DedicatedChannels";
import CloudStorage from "./CloudStorage";
import StructuredNetwork from "./StructuredNetwork";
import AdditionalServices from "./AdditionalServices";
import ServiceDeadlines from "./ServiceDeadlines";
import KakRabotaetInternet from "./KakRabotaetInternet";
import ChtoDelatEsliInternetPropal from "./ChtoDelatEsliInternetPropal";
import PriznakiChtoNuzhenSistemnyjAdministrator from "./PriznakiChtoNuzhenSistemnyjAdministrator";
import UstanavlivaemVideonablyudenieDlyaDachi from "./UstanavlivaemVideonablyudenieDlyaDachi";
import ProektirovanieSksFundamentNadezhnoyInfrastrukturyVashegoBiznesa from "./ProektirovanieSksFundamentNadezhnoyInfrastrukturyVashegoBiznesa";
import KakUsilitSignalWifiVKvartire from "./KakUsilitSignalWifiVKvartire";
import StaticheskyIliDinamycheskyIp from "./StaticheskyIliDinamycheskyIp";
import { FaTelegramPlane } from 'react-icons/fa';
import cityImage from './assets/city.webp';

export function Home() {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
  <>
     <Meta
        title="«ИТ Особа» — провайдер интернет-услуг, видеонаблюдения, виртуальных офисов и других решений."
        description="Провайдер «ИТ Особа» предлагает выгодные интернет-пакеты, аутсорсинг, услуги видеонаблюдения, виртуальные рабочие места, телефонию VoIP, облачное хранилище, проектирование инфраструктуры для бизнеса и прочие IT-услуги."
      />
      
     
      <div className="buttons-container container" style={{  display: 'grid',
                                                             gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                                             gap: '40px',}}>
        <Link to="./fiz-lico" className="button-card" data-aos="zoom-in" data-aos-delay="100" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Интернет городской (для физических лиц)</h3>
          <p>Мы предлагаем вам выгодные пакеты неограниченного доступа к
            Глобальной Сети </p>
        </Link>
        <Link to="./business" className="button-card" data-aos="zoom-in" data-aos-delay="200" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Интернет для бизнеса (юридических лиц)</h3>
          <p>Оператор быстрого подключения "ИТ Особа" предлагает оптимальные пакеты для подключения офисов и
            организаций</p>
        </Link>
        <Link to="./private-sector" className="button-card" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Интернет для частного сектора</h3>
          <p>Компания "ИТ Особа" предлагает подключение в частных домах и коттеджах.
            Вы получите быстрый и качественный интернет!</p>
        </Link>
        <Link to="./video" className="button-card" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Установка видеонаблюдения</h3>
          <p>Мы предлагаем установку видеонаблюдения на любых объектах</p>
        </Link>
        <Link to="./virtual_office" className="button-card3" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Виртуальные рабочие места (DaaS)</h3>
          <p>Создание инфраструктуры виртуальных рабочих столов</p>
        </Link>
        <Link to="./outsourcing" className="button-card3" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Аутсорсинг системного администрирования</h3>
          <p>Эффективный и экономичный аутсорсинг IT-услуг от "ИТ Особа"</p>
        </Link>
        <Link to="./voip_services" className="button-card3" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Подключение телефонии</h3>
          <p>Мы предлагаем услуги VoIP-телефонии и виртуальной АТС</p>
        </Link>
        <Link to="./dedicated_channels" className="button-card3" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Выделенные каналы связи для вашего бизнеса</h3>
          <p>"ИТ Особа" предлагает стабильную, быструю и защищенную связь</p>
        </Link>
        <Link to="./cloud_storage" className="button-card3" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Облачное хранение данных</h3>
          <p>Мы предлагаем надежное, масштабируемое и безопасное облачное хранение данных</p>
        </Link>
        <Link to="./structured_network" className="button-card3" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Проектирование и установка СКС</h3>
          <p>"ИТ Особа" предлагает надежное создание современной инфраструктуры</p>
        </Link>
        <Link to="./additional_services" className="button-card3" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Дополнительные услуги</h3>
          <p>"ИТ Особа" предлагает аренду ВОЛС, оптических лямбд, VLAN, L2VPN, Q in Q, MTU, QoS, корпоративный VPN, публичный Wi-Fi</p>
        </Link>
        <Link to="./service_deadlines" className="button-card3" data-aos="zoom-in" data-aos-delay="300" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <h3>Сроки устранения неисправностей</h3>
          <p>Здесь вы можете посмотреть сроки устранения неполадок</p>
        </Link>
      </div>
       {isDesktop && <News />}
    </>
  );
}

function Layout() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
  };


  return (
    <div className="app-container">
      <nav className="navbar">

        <div className="hamburger" onClick={toggleMenu} aria-label="Меню" role="button" tabIndex={0}>
          &#9776;
        </div>

        <div className={`nav-items ${isMenuOpen ? 'open' : ''}`}>


          <NavLink to="/" end className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}
          onClick={() => setIsMenuOpen(false)}>
            Главная
          </NavLink>

          <div className="nav-item dropdown"
              onMouseEnter={() => setIsMenuOpen(true)}     
              onMouseLeave={() => setIsMenuOpen(false)} >
            <NavLink
                to="/about"
                className={({isActive}) =>
                    isActive ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle'}
                onClick={() => setIsMenuOpen(true)}
            >
              О компании
            </NavLink>
            <div className={`dropdown-menu ${isMenuOpen ? 'open' : ''}`}>
              <NavLink to="/about/requisites" className="dropdown-item" onClick={() => setIsMenuOpen(false)}>
                Реквизиты
              </NavLink>
              <NavLink to="/about/jobs" className="dropdown-item" onClick={() => setIsMenuOpen(false)}>
                Вакансии
              </NavLink>
              <NavLink to="/about/license" className="dropdown-item" onClick={() => setIsMenuOpen(false)}>
                Лицензии
              </NavLink>
              <NavLink to="/about/coverage" className="dropdown-item" onClick={() => setIsMenuOpen(false)}>
                Карта покрытия
              </NavLink>
            </div>
          </div>

          <NavLink to="/services" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}
                   onClick={() => setIsMenuOpen(false)}>
            Услуги
          </NavLink>
          <NavLink to="/stock" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}

                   onClick={() => setIsMenuOpen(false)}>
            Акции
          </NavLink>
          <NavLink to="/help" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}
                   onClick={() => setIsMenuOpen(false)}>
            Помощь
          </NavLink>
          <NavLink to="/news" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}
          onClick={() => setIsMenuOpen(false)}>
            Новости
          </NavLink>
          <NavLink to="/contacts" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}
          onClick={() => setIsMenuOpen(false)}>
            Контакты
          </NavLink>
        </div>
        <div className="right-section">
          <a
              href="http://stat.itosoba.net/cabinet/welcome/"
              className="profile-button"
              target="_blank"
              rel="noopener noreferrer"
          >
            Личный кабинет
          </a>
        </div>
      </nav>

      <CityBanner/>
      <main><Outlet/></main>

      <footer className="footer" style={{ display: 'flex'}}>
        <div className="footer-contacts"
             style={{maxWidth: '350px', textAlign: 'left', padding: 0, marginTop: '5px', zIndex: '2'}}>
          <a
              href="/contacts"
              className="contacts-link"
              style={{
                margin: '0px',
                display: 'block',
                width: '100%',
                fontWeight: 'bold',
                textDecoration: 'none',
                color: '#A5A5A5',
                fontSize: '1.4rem'
              }}
          >
            Контакты:
          </a>
          <div className="contacts-details"
               style={{fontSize: '1.2rem', lineHeight: '1.1', textAlign: 'left', marginLeft: 8}}>
            <p style={{fontSize: '1.1rem'}}>
              <strong style={{color: '#A5A5A5', fontSize: '1.2rem'}}>Адрес офиса:</strong><br/>
              улица Правды, 28<br/>
              Подольск, Московская область, Россия
            </p>
            <p>
              <strong style={{color: '#A5A5A5', fontSize: '1.2rem'}}>Тел./факс:</strong>
              <a href="tel:+74994033148" style={{whiteSpace: 'nowrap', fontSize: '1.2rem'}}>
                +7 (499) 403-31-48
              </a>
            </p>
            <p>
              <strong style={{color: '#A5A5A5', fontSize: '1.2rem'}}>Почта:</strong>
              <a href="mailto:helpdesk@itosoba.ru" className="email-link" style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                textDecoration: 'none',
                fontSize: '1.2rem'

              }}>
                <span>helpdesk@itosoba.ru</span>
              </a>
            </p>
            <p>
              <strong style={{color: '#A5A5A5', fontSize: '1.2rem'}}>Телеграм-бот для клиентов:</strong>
              <a href="https://t.me/ItosobaClientBot" target="_blank" rel="noopener noreferrer"
                 className="telegram-link" style={{
                display: 'inline-flex',
                alignItems: 'left',
                fontSize: '1.2rem',
                gap: '6px',
                textDecoration: 'none',
              }}>
                <FaTelegramPlane size={20} color="#0088cc"/> @ItosobaClientBot
              </a>
            </p>
            <p>
              <strong style={{color: '#A5A5A5', fontSize: '1.2rem'}}>Whatsapp:</strong>
              <br/>
              <a
                  href="https://wa.me/+79263064040"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-link"
                  style={{display: 'inline-flex', alignItems: 'center', fontSize: '1.2rem', textDecoration: 'none'}}
              >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                    alt="WhatsApp"
                    style={{width: '24px', height: '24px', marginRight: '8px'}}
                />
                <span>89263064040</span>
              </a>
            </p>
          </div>
        </div>
        <div className="footer-links-container" style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center'}}>
          <ul className="footer-links"
              style={{listStyle: 'none', padding: 0, display: 'block', textAlign: 'right', margin: '13px', zIndex: '2'}}>
            <li>
              <Link to="/" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>Главная</Link>
            </li>
            <li>
              <Link to="/about/requisites"
                    onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>Реквизиты</Link>
            </li>
            <li>
              <Link to="/about/jobs" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>Вакансии</Link>
            </li>
            <li>
              <Link to="/about/license" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>Лицензии</Link>
            </li>
            <li>
              <Link to="/about/coverage" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>Карта
                покрытия</Link>
            </li>
            <li>
              <Link to="/services" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>Услуги</Link>
            </li>
            <li>
              <Link to="/news" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>Новости</Link>
            </li>
            <li>
              <Link to="/stock" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>Акции</Link>
            </li>
            <li>
              <Link to="/help" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>Помощь</Link>
            </li>
          </ul>
        </div>
        <div style={{width: '100%', textAlign: 'center', marginTop: '20px'}}>
          <p>© 2008-{new Date().getFullYear()} ООО «ИТ Особа». Все права защищены.</p>
        </div>
      </footer>

      <style>{`

        .hamburger {
          display: none;
          cursor: pointer;
          font-size: 24px;
        }

        .nav-items {
          display: flex;
          gap: 10px;
        }

        @media (max-width: 820px) {
          .hamburger {
            display: block; 
          }

          .nav-items {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            flex-direction: column;
            transform: scaleY(0);
            transform-origin: top;
            transition: transform 0.3s ease;
            overflow: hidden;
            max-height: 0;
            background: linear-gradient(135deg, #0a1f44, #112a66 70%);
            box-shadow: 0 4px 20px rgba(10, 31, 68, 0.9),
            inset 0 -2px 10px rgba(255, 255, 255, 0.05);
            font-family: 'Montserrat', sans-serif;
          }

          .nav-items.open {
            transform: scaleY(1);
            max-height: 500px; 
          }
        }
      `}</style>
    </div>
  );
}

export function CityBanner() {
  const location = useLocation();

  const filterClassMap = {
    '/': 'filter-default',
    '/about': 'filter-pink',
    '/about/requisites': 'filter-pink',
    '/about/jobs': 'filter-pink',
    '/about/license': 'filter-pink',
    '/about/coverage': 'filter-pink',
    '/services': 'filter-blue',
    '/news': 'filter-green',
    '/stock': 'filter-mango',
    '/help': 'filter-purple',     
    '/contacts': 'filter-yellow',
  };

  const [filterClass, setFilterClass] = useState(filterClassMap[location.pathname] || 'filter-default');
  const [fadeState, setFadeState] = useState('fade-in');

  useEffect(() => {
    const nextClass = filterClassMap[location.pathname] || 'filter-default';
    if (nextClass !== filterClass) {
      setFadeState('fade-out');

      const timeout = setTimeout(() => {
        setFilterClass(nextClass);
        setFadeState('fade-in');
      }, 500); 

      return () => clearTimeout(timeout);
    }
  }, [location.pathname]);

  return (
      <div className={`city-line ${fadeState} ${filterClass}`}>
        <img src={cityImage} fetchpriority="high" alt="ИТ Особа" className="city-image"/>

      <a href="/" className="logo-link">
           <div className="video-container">
            {/* <video
                 src={require('./assets/logo.webm')}
                 className="logo-video"
                autoPlay
                 muted
                 playsInline
                 onEnded={() => {
                 }}
             /> */}
             <img
             src={require('./assets/logo-ru.png')}
             className="logo-img-new"
             alt="ИТ Особа"
             />
             </div>
         </a>
         <a href="tel:+74994033148" className="phone-link">
           <span className="phone-number">8 (499) 403-31-48</span>
         </a>
       </div>
 );
 }


function App() {

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Layout/>,
      children: [
        { index: true, element: <Home /> },
      { path: 'fiz-lico', element: <FizLico /> },
      { path: 'business', element: <Business /> },
      { path: 'private-sector', element: <PrivateSector /> },
      { path: 'video', element: <Video /> },
      { path: 'virtual_office', element: <VirtualOfficePage /> },
      { path: 'outsourcing', element: <Outsourcing /> },
      { path: 'voip_services', element: <VoipServices /> },
      { path: 'dedicated_channels', element: <DedicatedChannels /> },
      { path: 'cloud_storage', element: <CloudStorage /> },
      { path: 'structured_network', element: <StructuredNetwork /> },
      { path: 'additional_services', element: <AdditionalServices /> },
      { path: 'service_deadlines', element: <ServiceDeadlines /> },
      {
        path: 'about',
        element: <About />,
        children: [
          { index: true, element: <Navigate to="requisites" replace /> },
          { path: 'requisites', element: <Requisites /> },
          { path: 'jobs', element: <Jobs /> },
          { path: 'license', element: <License /> },
          { path: 'coverage', element: <Coverage /> },
        ],
      },
      { path: 'services', element: <Services /> },
      { path: 'help', element: <Help />, },
      { path: 'kak_rabotaet_internet', element: <KakRabotaetInternet />, },
      { path: 'chto_delat_esli_internet_propal', element: <ChtoDelatEsliInternetPropal />, },
      { path: 'priznaki_chto_nuzhen_sistemnyj_administrator', element: <PriznakiChtoNuzhenSistemnyjAdministrator />, },
      { path: 'ustanavlivaem_videonablyudenie_dlya_dachi', element: <UstanavlivaemVideonablyudenieDlyaDachi />, },
      { path: 'proektirovanie_sks_fundament_nadezhnoy_infrastruktury_vashego_biznesa', element: <ProektirovanieSksFundamentNadezhnoyInfrastrukturyVashegoBiznesa />, },
      { path: 'kak_usilit_signal_wifi_v_kvartire', element: <KakUsilitSignalWifiVKvartire />, },
      { path: 'statichesky_ili_dinamychesky_ip', element: <StaticheskyIliDinamycheskyIp />, },
      { path: 'news', element: <News /> },
      { path: '/news/:id', element: <NewsDetail /> },
      { path: 'stock', element: <Stock /> },
      { path: 'contacts', element: <Contacts /> },
        {
          path: 'admin-login',
          element: <AdminLogin/>,
        },

      {
        path: 'admin',
        element: (
          <ProtectedRoute requiredRole="Admin">
              <AdminPanel/>
          </ProtectedRoute>
        ),
      },
      ],
    },
  ]);
  return <RouterProvider router={router} />;
}

export default App;
